


































import "./invite-modal.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "InviteModal",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      userResult: [],
      loading: false,
      sending: false,
      inviteModel: {
        email: null,
        role: 3,
        message: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Please fill in email",
            trigger: "blur",
          },
        ],
        message: [
          {
            required: true,
            message: "Please fill in message",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please choose permission",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles", "inviteMessage"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
  },
  watch: {
    showModal(newVal) {
      let context = this as any;

      if (newVal === true) {
        context.inviteModel.email = "";
        context.inviteModel.role = 3;
        context.inviteModel.message = context.inviteMessage;
      }
    },
  },
  methods: {
    searchUser(query) {
      if (query !== "") {
        this.loading = true;

        Ajax.post("/api/services/app/Billing/Search", { keyWord: query })
          .then((response) => {
            this.loading = false;
            this.userResult = response.data.result.items;

            this.users = this.userResult.map((item) => {
              let disabled = item.emailAddress == "admin2@defaulttenant.com" ? true : false;
              return {
                value: item.emailAddress,
                label: item.name,
                disabled,
              };
            });
          })
          .catch((error) => {
            this.loading = false;
          });
      } else {
        this.users = [];
      }
    },
    handleSend() {
      let context = this as any;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      (context.$refs["InviteForm"] as any).validate((valid) => {
        if (valid) {
          let user = context.userResult.filter((u) => u.emailAddress == context.inviteModel.email);
          let memberId = user && user.length > 0 ? user[0].id : NaN;

          context.$store
            .dispatch("billing/inviteMember", {
              data: {
                memberId: memberId,
                email: context.inviteModel.email,
                role: context.inviteModel.role,
                message: context.inviteModel.message,
                billingAccountId: context.billingAccount.id,
              },
            })
            .then((response) => {
              context.$store.dispatch("billing/getBillingAccountInfo", {
                id: context.billingAccount.id,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          context.sending = false;
          target.disabled = false;
          return;
        }
      });
    },
  },
});
